import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { RouterProvider } from 'react-router-dom'
import { createRouter } from './presentation/routes/appRoutes'
import './presentation/style/index.css'
import { createDefaultDIContainer } from './di/DIContainerFactory'
import { DIProvider } from './di/DIContext'

const rootElement = document.getElementById('root')

if (!rootElement) {
  throw new Error('Root element not found')
}

const diContainer = createDefaultDIContainer(window.fetch.bind(window))
const router = createRouter(diContainer)

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
})

createRoot(rootElement).render(
  <StrictMode>
    <DIProvider value={diContainer}>
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router} />
      </QueryClientProvider>
    </DIProvider>
  </StrictMode>,
)
